// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimDetails-cls1_rAE","cls2":"ClaimDetails-cls2_Kix ClaimDetails-cls1_rAE"};